module.exports = function(obj){
  if (obj === undefined){ return obj; }
  return JSON.parse(JSON.stringify(obj))
}



// WEBPACK FOOTER //
// ./src/utils/clone.js